import * as actionTypes from "../../../actions/actionTypes";
const personaliseExperience = (state = { themeArr: [] }, action) => {
  switch (action.type) {
    case actionTypes.SET_PERSONALISE_EXPERIENCE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default personaliseExperience;
